// country -> state/province code
export var ageRestrictions = {
    default: 21,
    US: {
        default: 21
    },
    CA: {
        default: 21,
        AB: 18,
        BC: 19,
        MB: 19,
        NB: 19,
        NL: 19,
        NT: 19,
        NS: 19,
        NU: 19,
        ON: 19,
        PE: 19,
        QC: 21,
        SK: 19,
        YT: 19
    }
};
